import React from 'react';
import { Box, Link, Paper, Typography } from '@mui/material';
import { RouteList } from 'types';

const links = [
  { title: 'Feedback geben', href: RouteList.Feedback },
  { title: 'Kontakt', href: RouteList.Contact },
  { title: 'AGB', href: RouteList.TermsAndConditions },
  { title: 'Datenschutz', href: RouteList.PrivacyPolicy },
  {
    title: 'Datenschutz Einstellungen',
    href: '#',
    onClick: () => {
      window.OneTrust && window.OneTrust.ToggleInfoDisplay();
    },
  },
];

export const PageFooter = () => {
  return (
    <Paper sx={{ borderRadius: 0, width: '100%' }}>
      <Box
        sx={{
          px: 6,
          py: 3,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ order: { xs: 2, sm: 0 }, textAlign: { xs: 'center', sm: 'left' } }}>
          {links.map((link) => (
            <Link
              key={link.title}
              href={link.href}
              onClick={link.onClick}
              sx={{ color: 'grey.500', fontSize: 12, mr: 4 }}
            >
              {link.title}
            </Link>
          ))}
        </Box>
        <Box sx={{ order: { xs: 1, sm: 0 }, textAlign: { xs: 'center', sm: 'left' } }}>
          <Typography sx={{ color: 'grey.500', fontSize: 12 }}>© Alloy Ads by Ringier AG</Typography>
        </Box>
      </Box>
    </Paper>
  );
};
